import { Action } from 'redux';
import { DeskOpeningExceptionModel } from '../../../api/core/core.types';

export const GET_DESK_OPENING_EXCEPTION_LIST = 'GET_DESK_OPENING_EXCEPTION_LIST';
export const POST_DESK_OPENING_EXCEPTION = 'POST_DESK_OPENING_EXCEPTION';
export const PUT_DESK_OPENING_EXCEPTION = 'PUT_DESK_OPENING_EXCEPTION';
export const DELETE_DESK_OPENING_EXCEPTION = 'DELETE_DESK_OPENING_EXCEPTION';

export interface GetDeskOpeningExceptionListActuion extends Action {
  type: typeof GET_DESK_OPENING_EXCEPTION_LIST;
  payload: {
    deskOpeningExceptions: DeskOpeningExceptionModel[];
  };
}

export interface PostDeskOpeningExceptionAction extends Action {
  type: typeof POST_DESK_OPENING_EXCEPTION;
  payload: {
    success: boolean;
    newDeskOpeningException: DeskOpeningExceptionModel | null;
  };
}

export interface PutDeskOpeningExceptionAction extends Action {
  type: typeof PUT_DESK_OPENING_EXCEPTION;
  payload: {
    selectedDeskOpeningException: DeskOpeningExceptionModel;
  };
}

export interface DeleteDeskOpeningExceptionAction extends Action {
  type: typeof DELETE_DESK_OPENING_EXCEPTION;
  payload: {
    success: boolean;
  };
}

export interface DeskOpeningExceptionState {
  deskOpeningExceptions: DeskOpeningExceptionModel[] | [];
  selectedDeskOpeningException: DeskOpeningExceptionModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
}

export type DeskOpeningExceptionActionTypes = GetDeskOpeningExceptionListActuion | PostDeskOpeningExceptionAction | PutDeskOpeningExceptionAction | DeleteDeskOpeningExceptionAction;
